import React from 'react';
import 'material-icons/iconfont/material-icons.css';
import { Routes } from 'react-router-dom';
import styled from 'styled-components';

// import AdmRoutes from './Rotas/AdmRoutes';
import AdmRoutes from './Rotas/AdmRoutes';
import HomeRoutes from './Rotas/HomeRoutes';
import MedsusRoutes from './Rotas/MedsusRoutes';
import MeusDadosRoutes from './Rotas/MeusDadosRoutes';
import ProdutosDAFRoutes from './Rotas/ProdutosDAFRoutes';
import ProgramacaoRoutes from './Rotas/ProgramacaoRoutes';
import Breadcrumbs from '../../../components/BreadCrumb';
import Sidebar from '../../../components/Sidebar';
import {
  isAdmin,
  // isAdmin,
  useNomeCompleto,
} from '../../../modules/contexts/userContexts';

const Container = styled.div`
  display: grid;
  // max-content - ocupa exatamente o tamanho necessário para o conteúdo mais largo dentro da sidebar (sem quebrar o texto)
  // 1fr (uma fração do espaço restante) para ocupar o espaço restante
  grid-template-columns: max-content 1fr;
  min-height: 100vh;
`;

const WorkspaceContainer = styled.div`
  display: grid;
  grid-template-rows: 5vh 95vh;
`;

const Workspace = styled.div`
  background-color: ${({ theme }) => theme.colors.fundo};
  height: calc(100vh - 5vh);
  overflow-x: hidden;
  display: grid;
  grid-template-rows: 5% 90% 5%;
`;
const dominioSes = 'secsaude';
const AppSES: React.FC = () => {
  const { papel } = useNomeCompleto();
  const isUserAdmin = isAdmin(papel);

  return (
    <Container>
      <Sidebar />
      <WorkspaceContainer>
        <Breadcrumbs tipoSubdominio={dominioSes} />
        <Workspace>
          <Routes>
            {HomeRoutes()}
            {ProdutosDAFRoutes()}
            {ProgramacaoRoutes()}
            {MeusDadosRoutes()}
            {MedsusRoutes()}
            {isUserAdmin && AdmRoutes()}
          </Routes>
        </Workspace>
      </WorkspaceContainer>
    </Container>
  );
};

export default AppSES;
